import React from 'react';
import {useTranslation} from 'react-i18next';
import {WarningCircle} from '../../../icons';
import {
    NS,
    formatAmount,
    formatLongDate,
    liquidationAmountOf,
    payableCouponOf,
    periodLabelOf,
} from './subscriptionPageModel';
import {BankTransferDetails, LinkButton} from './SubscriptionParts';
import {recordSubscriptionEvent} from './subscriptionRequests';

const RAW = {escapeValue: false};

/**
 * La factura vencida, arriba de todo (mockup 5): la más vieja, con la fecha de corte si Tesla la sabe y,
 * con transferencia, los datos para pagarla ahí mismo.
 *
 * `role="alert"` se anuncia al INSERTARSE: la `key` del padre es el id de la factura, así que el refresco
 * de 30 s (que trae la misma) no vuelve a anunciarlo; sólo una factura distinta lo hace.
 */
export function OverdueNotice({overdue, bankLines, onNotify, onPaymentProblem}) {
    const {t, i18n} = useTranslation();
    const lang = i18n && i18n.language;
    const {oldest, count} = overdue;
    const {amount, currency} = liquidationAmountOf(oldest);
    const formattedAmount = formatAmount(amount, currency, lang);
    const period = periodLabelOf(oldest, lang);
    const coupon = payableCouponOf(oldest);

    const facts = [period, formattedAmount].filter(Boolean).join(' · ');
    const body = oldest.due_date
        ? t(`${NS}.overdue.body`, {
            period, amount: formattedAmount, date: formatLongDate(oldest.due_date, lang), interpolation: RAW,
        })
        : facts;

    return (
        <section className="sp-alert" role="alert" aria-labelledby="sp-overdue-title" data-testid="sp-overdue">
            <WarningCircle size={26} weight="bold" className="sp-alert__icon" aria-hidden="true"/>
            <div className="sp-alert__body">
                <h2 id="sp-overdue-title" className="sp-alert__title">{t(`${NS}.overdue.title`, {count})}</h2>
                <p className="sp-alert__text">
                    {body}
                    {oldest.suspension_date && (
                        <> {t(`${NS}.overdue.cutoff`, {date: formatLongDate(oldest.suspension_date, lang), interpolation: RAW})}</>
                    )}
                </p>
                <div className="sp-actions">
                    {/* «Pagar» sin monto: el cupón cobra lo de la factura (con IVA, o en pesos con MercadoPago),
                        que puede no ser el monto de arriba (C-sp-fe-01). */}
                    {coupon && (
                        <a className="btn -alt" href={coupon.payment_url} target="_blank" rel="noopener noreferrer"
                           onClick={() => recordSubscriptionEvent('pay_click')}>
                            {t(`${NS}.payments.pay`)}
                        </a>
                    )}
                    {/* El aviso lo puede mandar todo el equipo, admin o no (contrato §9). */}
                    <button type="button" className="btn -alt -negative" onClick={() => onNotify(oldest)}>
                        {t(`${NS}.overdue.i_paid`)}
                    </button>
                    <LinkButton onClick={() => onPaymentProblem(period)}>{t(`${NS}.overdue.help`)}</LinkButton>
                </div>
                <BankTransferDetails lines={bankLines} titleId="sp-overdue-transfer"/>
            </div>
        </section>
    );
}
